// frontend/src/services/uploadImagem.js
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';

/**
 * Faz upload de uma imagem para o Firebase Storage e retorna { url, path }.
 * - Valida tipos/formatos aceitos (JPG/PNG/WEBP/GIF).
 * - Gera nome seguro para o arquivo.
 * - Inclui contentType nos metadados para garantir renderização correta.
 */
export const uploadImagem = async (
  file,
  usuario,
  pastaBase = 'imoveis',
  fileName
) => {
  if (!file) throw new Error('Nenhum arquivo fornecido para upload.');
  if (!usuario?.uid) throw new Error('Usuário inválido no upload.');

  // 🔎 Extensões permitidas
  const allowedExt = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
  const ext = (file.name?.split('.').pop() || '').toLowerCase();

  if (!allowedExt.includes(ext)) {
    throw new Error(
      `Formato de imagem não suportado: .${ext}. Use JPG, PNG, WEBP ou GIF.`
    );
  }

  // Nome seguro (sem espaços/caracteres estranhos)
  const safeName = (fileName || file.name || 'imagem')
    .replace(/\s+/g, '_')
    .replace(/[^\w.-]/gi, '');

  const path = `${pastaBase}/${usuario.uid}/${Date.now()}_${safeName}`;
  const storageRef = ref(storage, path);

  const metadata = { contentType: file.type || `image/${ext}` };

  // 📤 Upload e retorno da URL
  const snap = await uploadBytes(storageRef, file, metadata);
  const url = await getDownloadURL(snap.ref);

  return { url, path };
};
